// Feedback modal for users to send feedback on an exercise
export const feedbackDialog = (minChars, maxChars) => ({
  minChars,
  maxChars,
  showConfirmExit: false,
  sent: false,
  message: '',
  url: null,
  licenseClassId: null,

  async submit() {
    if (this.invalid) return

    const body = { license_class_id: this.licenseClassId, message: this.message }
    const req = new FetchRequest('post', this.url, { body })
    const res = await req.perform()

    if (res.ok) {
      this.sent = true
      setTimeout(() => this.close(), 2000)
    } else {
      alert('Sorry, something went wrong')
    }
  },
  openFeedbackDialog(url, licenseClassId) {
    this.message = ''
    this.sent = false
    this.url = url
    this.licenseClassId = licenseClassId
    this.showConfirmExit = false

    const dialog = this.$refs.feedbackDialog
    dialog.showModal()
    document.body.classList.add('disable-scroll')
    dialog.addEventListener('click', (e) => {
      e.target === dialog && !this.chars && this.close()
    })
  },
  close() {
    document.body.classList.remove('disable-scroll')
    this.$refs.feedbackDialog.close()
  },
  get chars() {
    return this.message.trim().length
  },
  get invalid() {
    return this.chars < this.minChars || this.chars > this.maxChars
  },
})
